type OnScrollProps = {
  onChangeFn: ((change: number) => void) | undefined;
  scrollState: boolean;
  checkScroll: () => void;
};
export const onCarouselScroll =
  ({ onChangeFn, scrollState, checkScroll }: OnScrollProps) =>
  ({ target }: Event) => {
    const { scrollLeft } = target as HTMLDivElement;
    if (!scrollState && onChangeFn) onChangeFn(scrollLeft);
    checkScroll();
  };
